import React from 'react'
import PropTypes from 'prop-types'

import Box from 'components/_new/layout/Box/Box'
import Button from 'components/_new/Button/Button'
import Field from 'components/_new/forms/Field/Field'

import messages from './messages'
import s from './Mobile.scss'


const Mobile = ({ field, inputId, loading, onSubmit }) => (
  <Box className={s.container} p="16">
    <Field
      field={field}
      placeholder={messages.placeholder}
      id={inputId}
      standardView
    />
    <Box mt="8">
      <Button
        title={messages.buttonTitle}
        loading={loading}
        color="brand"
        size="md"
        fullWidth
        onClick={onSubmit}
      />
    </Box>
  </Box>
)


Mobile.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}


export default Mobile
